import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import en from '../../../international/translations/en';
import config from '../../../config';
import convertToMonthlyCost from '../../../utils/convertToMonthlyCost';
class GoPremium extends Component {
  static propTypes = {
    brand: PropTypes.string
  }

  constructor(props) {
    super(props);
    this.analyticsJoinPremiumClicked = this.analyticsJoinPremiumClicked.bind(this);
  }

  analyticsJoinPremiumClicked = () => {
    window.analytics.track(
      `Clicked Subscribe CTA`,
      {
        ctaLocation: 'subscription-details',
        brand: this.props.brand
      }
    );
  }

  monthlyCost = () => {
    const cents = convertToMonthlyCost(this.props.plan.amount, this.props.plan.interval);
    const cost = `$${parseFloat((cents / 100)).toFixed(2)}/mo`;
    return cost;
  };

  render() {
    const { brand } = this.props;

    return (
      <div className="goPremium">
        <div className="goPremium__icon__container">
          <div className="goPremium__icon__block">
            <i className="goPremium__icon fa fa-plus" aria-hidden="true"></i>
          </div>
        </div>
        <div className="goPremium__text__container">
          <div className="goPremium__heading">{en.subscription.goPremium[brand].company_premium}</div>
          <div className="goPremium__subheading">{en.subscription.goPremium[brand].desc}
            <a className="goPremium__subheading__link" href={en.subscription.goPremium[brand].benefitsLink} target="_blank">
              {en.subscription.goPremium.learn_more}
            </a>
          </div>
        </div>
        <div className="goPremium__btn__container">
          <a
            onClick={this.analyticsJoinPremiumClicked}
            href={`${en.subscription.goPremium[brand].upgrade_link}${config.relativeUpgradeRedirectUrl}`}
            className="goPremium__btn"
            role="button">{this.monthlyCost()}
          </a>
        </div>
      </div>
    );
  }
}

export default connect()(GoPremium);
